<template>
  <!-- <div class="home-page"> -->
  <div v-if="openId" class="home-page">
    <div class="tab">
      <van-tabs
        color="#ff6927"
        v-model="clueType"
        line-width="16"
        title-active-color="#ff6927"
        @click="onChange"
      >
        <van-tab title="文章" name="Article">
          <div class="tabBox_time">
            <div
              v-for="(type,index) in clueTimeTypes"
              :key="index+'0'"
              @click="getDataListByTime(type)"
              v-bind:class="{active:type.isActive}"
            >
              <span>
                <van-icon name="underway-o" size="18" style="position: relative; top: 3.5px;" />
              </span>
              {{type.name}}
            </div>
          </div>
        </van-tab>
        <van-tab title="图文/视频" name="PAWVOD">
          <div class="tabBox_time">
            <div
              v-for="(type,index) in clueTimeTypes"
              :key="index+'1'"
              @click="getDataListByTime(type)"
              v-bind:class="{active:type.isActive}"
            >
              <span>
                <van-icon name="underway-o" size="18" style="position: relative; top: 3px;" />
              </span>
              {{type.name}}
            </div>
          </div>
        </van-tab>
        <van-tab title="活动" name="Activity">
          <div class="tabBox_time">
            <div
              v-for="(type,index) in clueTimeTypes"
              :key="index+'2'"
              @click="getDataListByTime(type)"
              v-bind:class="{active:type.isActive}"
            >
              <span>
                <van-icon name="underway-o" size="18" style="position: relative; top: 3px;" />
              </span>
              {{type.name}}
            </div>
          </div>
        </van-tab>
        <!-- <van-tab title="名片" name="Card">
          <div class="tabBox_time">
            <div
              v-for="(type,index) in clueTimeTypes"
              :key="index+'3'"
              @click="getDataListByTime(type)"
              v-bind:class="{active:type.isActive}"
            >
              <span>
                <van-icon name="underway-o" size="18" style="position: relative; top: 3px;" />
              </span>
              {{type.name}}
            </div>
          </div>
        </van-tab> -->
      </van-tabs>
    </div>
    <div class="content" v-if="clueType=='Article'">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="article_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="我也是有底线的~~~"
          @load="onLoad"
        >
          <van-row>
            <div class="list_item" v-for="(item,index) in articleList" :key="index+'00'">
              <div class="article_pic_wrap">
                <van-image height="70" width="92" :src="item.coverLink" fit="cover" error-icon />
                <div class="clueNum">
                  <p @click="getClueDetails(item,'BROWSE')">
                    <span>
                      <img src="./img/visite1.png" alt />
                      浏览
                    </span>
                    <span style="color:#ff6927;">&nbsp;{{item.viewCount}}</span>
                  </p>
                  <p @click="goToTree(item,'FORWARD')">
                    <span class="share">
                      <img src="./img/share0.png" alt />
                      传播范围
                    </span>
                    <span style="color:#ff6927;"></span>
                  </p>
                </div>
                <div class="van-multi-ellipsis--l2 article_title">{{item.title}}</div>
              </div>
            </div>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="content" v-if="clueType=='Activity'">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="article_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="我也是有底线的~~~"
          @load="onLoad"
        >
          <van-row>
            <div class="list_item" v-for="(item,index) in articleList" :key="index+'11'">
              <div class="article_pic_wrap active">
                <van-image
                  height="60"
                  width="60"
                  :src="item.showList_imgUrl"
                  fit="cover"
                  error-icon
                  style="margin-left:10px"
                />
                <p
                  class="ac_type"
                >{{item.activitie_types=='W'?'问卷':(item.activitie_types=='D'?'活动':'活动+转盘')}}</p>
                <div class="clueNum">
                  <p @click="getClueDetails(item,'BROWSE')">
                    <span>
                      <img src="./img/visite1.png" alt />
                    </span> 浏览
                    <span style="color:#ff6927;">&nbsp;{{item.viewCount}}</span>
                  </p>
                  <p @click="goToTree(item,'FORWARD')">
                    <span class="share">
                      <img src="./img/share1.png" alt />
                    </span> 传播范围
                    <span style="color:#ff6927;"></span>
                  </p>
                </div>
                <div class="van-multi-ellipsis--l2 article_title">
                  <p>{{item.activitie_description}}</p>
                </div>
              </div>
            </div>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="content" v-if="clueType=='PAWVOD'">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="article_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="我也是有底线的~~~"
          @load="onLoad"
        >
          <van-row>
            <div class="list_item" v-for="(item,index) in articleList" :key="index+'12'">
              <div class="article_pic_wrap">
                <van-image
                  height="70"
                  width="92"
                  :src="item.contentType=='PAW'?item.imgurl1:item.faceimgurl"
                  fit="cover"
                  error-icon
                />
                <div class="clueNum">
                  <p @click="getClueDetails(item,'BROWSE')">
                    <span>
                      <img src="./img/visite1.png" alt />
                      浏览
                    </span>
                    <span style="color:#ff6927;">&nbsp;{{item.viewCount}}</span>
                  </p>
                  <p @click="goToTree(item,'FORWARD')">
                    <span class="share">
                      <img src="./img/share.png" alt />
                      传播范围
                    </span>
                    <span style="color:#ff6927;"></span>
                  </p>
                </div>
                <div class="van-multi-ellipsis--l2 article_title">{{item.artcSummary}}</div>
              </div>
            </div>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="content" v-if="clueType=='Card'">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          class="article_list"
          v-model="loading"
          :immediate-check="false"
          :finished="finished"
          finished-text="我也是有底线的~~~"
          @load="onLoad"
        >
          <van-row>
            <div class="list_item" v-for="(item,index) in personList" :key="index+'13'">
              <div class="header_pic_wrap">
                <van-image height="42" width="42" :src="item.headimgurl" error-icon />
                <div class="right">
                  <div>{{item.nickname}}</div>
                  <div class="bot">
                    <div>
                      <div>
                        <img src="./img/visite.png" alt />
                      </div>
                      <p>{{item.viewCount}}</p>
                    </div>
                    <div>
                      <div>
                        <img class="time" src="./img/time.png" alt />
                      </div>
                      <p>{{item.viewDuration}}s</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-overlay :show="pageTip">
      <div class="wrapper">
        <div class="hasPower">
          <p>您没有相应的权限，请购买服务！</p>
          <div class="btnBox">
            <div @click="gotoBuy">确认</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast } from "vant";
export default {
  name: "home",
  data() {
    return {
      searchValue: "",
      pageTip: false,
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1, //请求第几页
      pageSize: 10, //每页请求的数量
      total: 0, //总共的数据条数
      articleList: [],
      personList: [],
      // clueTypes: [
      //   { type: "Article", name: "文章", isActive: true },
      //   { type: "Activity", name: "活动", isActive: false },
      //   { type: "PostCard", name: "海报", isActive: false }
      //   // {type:'video',name:'短视频',isActive:false},
      // ],
      clueTimeTypes: [
        { type: "0", name: "全部", isActive: false },
        { type: "7", name: "近7天", isActive: true },
        { type: "30", name: "近30天", isActive: false }
      ],
      clueType: "Article",
      clueTimeType: "7",
      openId: '',
      isVip: true,
      host: '',
      cardId: '',
    };
  },
  created() {
    Toast.loading({
      message: "加载中...",
      duration: 0,
      forbidClick: true,
    });
    if (sessionStorage.getItem('content_type')) {
      if (sessionStorage.getItem('content_type') == 'art') {
        this.clueType = 'Article'
      } else {
        this.clueType = 'PAWVOD'

      }

    }
  },
  mounted() {
    // this.getCradId()
    // if (location.hostname === "dtfcloud.com") {
    //   this.appId = "wxae0168c583647722";
    //   this.host="https://ufc.dtfcloud.com"
    // } else {
    //   this.host="http://www.bjnfbk.com"
    //   this.appId = "wxae0168c583647722";
    // }
    // 本地调试
    // this.openId = "o79BZs_7OE8ADTnCDoLSVKNWk9hc";
    //  sessionStorage.setItem("openId","o79BZsyhwH-UdEXw2dKiTbSm5w1s");
    // sessionStorage.setItem("unionid", 'oa9Qh6FJIohtG4cRDKfPK0d4g_A8')
    // sessionStorage.setItem("unionid", 'oP22H5hNvYVvb92xlAnM6e4EcoIs')
    // this.$store.state.openId="o79BZs9DLVCmQHC0po6wGsFZvGIQ";
    // sessionStorage.setItem("openId", "oP22H5hNvYVvb92xlAnM6e4EcoIs");
    // this.checkAuth(this.openId)
    this.openId = sessionStorage.getItem('openId');
  
    this.getDataList(this.clueType, this.clueTimeType);
    this.confingInfo(sessionStorage.getItem('openId'))
    // --本地调试
    // this.$store.state.code = this.getUrlParams("code"); //获取code
    
    

  },
  methods: {
    initialization() {
      this.articleList = [];
      this.pageNum = 1;
      this.loading = true; //下拉加载中
      this.finished = false; //下拉结束
      if (this.loading) {
        this.onLoad();
      }
    },
    checkAuth(id) {
      // let that = this;
      this.$fetchPost(URL.getAuthentication.url, {
        "openid": id,
        "id": "5",
        "unionid": localStorage.getItem('unionid')
      })
        .then(res => {
          this.getDataList(this.clueType, this.clueTimeType);
          this.confingInfo(this.$store.state.openId)
          Toast.clear();

          if (res.data == 0) {
            this.isVip = true;
            sessionStorage.setItem('isVip', 'y')
            this.pageTip = false;
          }
          else if (res.data == 1) {
            this.pageTip = true
            // Dialog.alert({
            //   message:'您没有相应的权限，请购买服务！',
            // })
            // .then(()=>{
            //   window.location.href = this.host+'/wxPay/index.html#/'
            // })
            // .catch(()=>{

            // })

            // window.location.href = 'https://ufc.dtfcloud.com/insservice/wxPay/index.html#/';
          }
        })
        .catch(err => {
        })
    },
    gotoBuy() {
      window.location.href = this.host + '/wxPay/index.html#/';
    },
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    confingInfo(id) {
      this.$fetchGet(URL.updateMyInfo.url, { openId: id }).then(res => {

      });

    },
    goAuthorize: function () {
      // window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.appId + "&redirect_uri=" + encodeURIComponent(location.href) + "&response_type=code&scope=snsapi_base&state=1&connect_redirect=1#wechat_redirect");
    },
    getOpenID: function () {
      this.$fetchPost(URL.getUserInfo.url, { userCode: this.getUrlParams("code") }).then(res => {
        if (res.data.msg === "成功") {
          if (res.data.openId) {
            sessionStorage.setItem("openId", res.data.openId);
            this.$store.state.openId = res.data.openId
            sessionStorage.setItem('unionid', res.data.unionid)
            sessionStorage.setItem('headerUrl', res.data.headImgUrl)
            this.openId = res.openId;
            this.checkAuth(res.openId)
            this.getCradId()
            // that.getDataList(this.clueType, this.clueTimeType);
            // that.confingInfo(that.$store.state.openId)
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    onChange(name, title) {
      if (title === "文章") {
        this.clueType = "Article";
        // this.getDataList(this.clueType, this.clueTimeType, "1");
      } else if (title === "活动") {
        this.clueType = "Activity";
        // this.getDataList(this.clueType, this.clueTimeType, "1");
      } else if (title === "图文/视频") {
        this.clueType = "PAWVOD";
        // this.getDataList(this.clueType, this.clueTimeType, "1");
      } else {
        this.clueType = 'Card'
      }
      this.initialization();
    },
    getDataListByTime(time) {
      this.articleList = [];
      for (var j = 0; j < this.clueTimeTypes.length; j++) {
        this.clueTimeTypes[j].isActive = false;
      }
      time.isActive = true;
      this.clueTimeType = time.type;
      this.initialization();
      // this.getDataList(this.clueType,time.type,'1')
    },
    getDataList(type, time, pageNum) {
      let that = this;
      that.$fetchPost(URL.getClueList.url, {
        pageNo: pageNum ? pageNum : that.pageNum,
        type: type,
        day: time,
        pageSize: that.pageSize,
        openId: sessionStorage.getItem('openId'),
        unionid: localStorage.getItem('unionid')
      })
        .then(res => {
          let list = res.data.data.list; //请求返回当页的列表
          that.refreshing = false;
          that.loading = false;
          Toast.clear();
          that.total = res.data.data.total;
          if (list == null || list.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          if (that.pageNum > 1) {
            that.articleList = [...that.articleList, ...list];
          } else {
            that.articleList = list;
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.articleList.length >= that.total) {
            that.finished = true;
          }
          // 如果总页数大于当前页码，页码+1
          if (res.data.data.pages > that.pageNum) {
            that.pageNum++;
          }
        });
    },

  
    onLoad() {
      if (this.clueType != 'Card') {
        this.getDataList(this.clueType, this.clueTimeType);
      } else {
        this.getPersonList(this.clueTimeType);
      }
    },
    onRefresh() {
      this.searchValue = "";
      this.pageNum = 1;
      this.finished = false;
      this.getDataList(this.clueType, this.clueTimeType);
    },
    onSearch() {
      this.finished = false;
      this.pageNum = 1;
      this.getArticleList();
    },
    goToDetails(id, imgUrl) {
      this.$router.push({
        name: "articleDetails",
        query: {
          articleId: id,
          picUrl: imgUrl
        }
      });
    },
    goToTree(item) {
      this.$router.push({
        name: "shareLink",
        query: {
          activitie_id: item.artcId,
          day: this.clueTimeType
        }
      });
    },
    getClueDetails(item, type) {
      if (this.clueType == "Article") {
        sessionStorage.setItem('activitie_id', item.artcId)
        this.$router.push({
          path: "/clueDetails",
          query: {
            activitie_id: item.artcId,
            tendsType: type,
            day: this.clueTimeType
          }
        });
      }
      if (this.clueType == "Activity") {
        sessionStorage.setItem('activitie_id', item.activitie_id)
        this.$router.push({
          path: "/clueDetails",
          query: {
            activitie_id: item.activitie_id,
            tendsType: type
          }
        });
      }
      if (this.clueType == "PAWVOD") {
        sessionStorage.setItem('activitie_id', item.artcId)
        this.$router.push({
          path: "/clueDetails",
          query: {
            activitie_id: item.artcId,
            tendsType: type
          }
        });
      }
      sessionStorage.setItem('tendsType', type)
    },
  }
};
</script>

<style lang="less">
.home-page {
  position: relative;
  height: 100%;
  font-size: 14px;
  .tab {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    background: #fff;
    // display: flex;
    [class*="van-hairline"]::after {
      border: none;
    }
    .van-tab {
      font-size: 18px;
      // padding: 0 16px;
    }
    .tabBox_time {
      display: flex;
      text-align: center;
      font-size: 14px;
      // width: 90%;
      margin: 0 auto;
      height: 30px;
      line-height: 30px;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      div {
        height: 30px;
        line-height: 30px;
        flex: 1;
        background: #fff;
        border-radius: 3px;
        margin: 10px 16px;
        font-size: 14px;
      }
      div:nth-child(1) {
        text-align: left;
      }
      div:nth-child(3) {
        text-align: right;
      }
      .active {
        color: #ff6927;
        // text-decoration: underline;
      }
    }
  }
  .content {
    padding: 90px 0 44px;
    height: 100%;
    background: #f5f5f5;
    overflow-y: auto;
    .van-pull-refresh {
      // height: 100%;
    }
    .article_list {
      // *{ touch-action: none; }
      width: 100%;
      height: 100%;
      .van-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .list_item {
          width: 100%;
          background: #fff;
          margin-bottom: 4px;
          position: relative;
          padding: 16px;
          .clueNum {
            position: absolute;
            width: 70%;
            left: 104px;
            bottom: 5px;
            display: flex;
            p {
              color: #ff6927;
              // flex: 1;
              margin-right: 16px;
              font-size: 12px;
              line-height: 14px;
              span {
                img {
                  display: inline-block;
                  width: 16px;
                  height: 12px;
                  margin-top: 2px;
                  vertical-align: middle;
                  margin-top: -2px;
                  margin-right: 2px;
                }
              }
              span.share {
                img {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }
          .article_pic_wrap {
            position: relative;
            // padding: 5px 0;
            .badge {
              position: absolute;
              bottom: 4px;
              right: 0;
              width: 46px;
              height: 18px;
              line-height: 18px;
              background-color: #5b9bd5;
              color: #fff;
              text-align: center;
              font-size: 12px;
            }
            .van-image {
              /deep/.van-image__error,
              /deep/ .van-image__img,
              /deep/ .van-image__loading {
                border-radius: 3px;
              }
              border-radius: 3px;
              overflow: hidden;
            }
            img {
              border-radius: 3px;
            }
          }
          .header_pic_wrap {
            display: flex;
            .van-image {
              /deep/.van-image__error,
              /deep/ .van-image__img,
              /deep/ .van-image__loading {
                border-radius: 21px;
              }
              border-radius: 21px;
              overflow: hidden;
            }
            .right {
              position: relative;
              flex: none;
              color: #333;
              margin-left: 10px;
              .bot {
                display: flex;
                margin-top: 10px;
                div {
                  display: flex;
                  line-height: 14px;
                  div {
                    color: #333;
                    width: 14px;
                    height: 12px;
                    margin-right: 10px;
                    img {
                      width: 100%;
                    }
                    .time {
                      width: 14px;
                      height: 14px;
                    }
                  }
                  p {
                    margin-right: 10px;
                  }
                }
              }
            }
          }
          .article_pic_wrap.active {
            p.ac_type {
              width: 76px;
              text-align: center;
              color: #ff6927;
            }
            p.ac_name {
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .article_title {
            font-size: 16px;
            color: #1a1a1a;
            position: absolute;
            width: 65%;
            top: 0px;
            left: 104px;
          }
        }
      }
    }
    .van-list {
      /deep/ .van-list__error-text,
      /deep/ .van-list__finished-text,
      /deep/ .van-list__loading {
        width: 100%;
      }
    }
  }
  .publish {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .hasPower {
      width: 271px;
      height: 180px;
      padding: 40px 28px 20px;
      text-align: center;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      background: #fff;

      p {
        font-size: 16px;
        line-height: 26px;
      }
      .btnBox {
        display: flex;
        justify-content: center;
        div {
          width: 120px;
          // padding: 0 12px;
          height: 38px;
          color: #fff;
          line-height: 38px;
          text-align: center;
          background: #ff6927;
          border-radius: 19px;
        }
      }
    }
  }
}
</style>
